$(document).ready(function(){
  $('.product-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,

   
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0652/1071/2148/files/arrow.png?v=1757422648" alt="Prev"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0652/1071/2148/files/arrow.png?v=1757422648" alt="Next"></button>',
     responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 }},
      { breakpoint: 768, settings: { slidesToShow: 1 }},
      { breakpoint: 480, settings: { slidesToShow: 1 }}
    ]
  });
});


$(document).ready(function() {
  $('.card-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".description-tab-btn .sub-heading");
  const tabContents = document.querySelectorAll(".description-tab-container .content-box");

  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const target = button.getAttribute("data-tab");

      // Remove active class from all
      tabButtons.forEach(btn => btn.classList.remove("active"));
      tabContents.forEach(content => content.classList.remove("active"));

      // Add active class to clicked button and matching content
      button.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const cartForm = document.querySelector("form.cart");
  if (!cartForm) return;

  // Quantity change
  cartForm.addEventListener("change", function (e) {
    if (e.target.classList.contains("quantity__input")) {
      updateCart(e.target.dataset.index, e.target.value);
    }
  });

  // Plus / minus buttons
  cartForm.addEventListener("click", function (e) {
    if (e.target.closest(".quantity__button")) {
      const btn = e.target.closest(".quantity__button");
      const input = btn.parentElement.querySelector(".quantity__input");
      let newQty = parseInt(input.value);

      if (btn.name === "plus") newQty++;
      if (btn.name === "minus") newQty--;

      if (newQty < 0) newQty = 0;

      updateCart(input.dataset.index, newQty);
    }
  });

  // Remove button
  cartForm.addEventListener("click", function (e) {
    if (e.target.closest(".cart-remove-button")) {
      e.preventDefault();
      const btn = e.target.closest("cart-remove-button");
      const index = btn.dataset.index;
      updateCart(index, 0);
    }
  });

  function updateCart(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count > 0) {
          location.reload(); // Simple refresh (can be replaced with dynamic DOM update)
        } else {
          document.querySelector(".custom-cart-page").innerHTML = `
            <div class="empty-cart container">
              <h2>Your cart is currently empty.</h2>
              <a href="${window.routes.all_products_collection_url}" class="btn">Continue Shopping</a>
            </div>
          `;
        }
      });
  }
});
